import {
  AccordionProps,
  AccordionSummary,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PropsWithChildren, ReactNode } from 'react';

import { getDataTestId } from '@/utils/browser';

import { StatusIcon } from '../../DataDisplay/StatusIcon';

import { DocumentAccordionDetails, StyledAccordion } from './ActionList.styled';

type ActionAccordionProps = {
  title: string;
  description?: string;
  defaultExpanded?: boolean;
  disabled?: boolean;
  status?: string;
  expanded?: boolean;
  onChange?: AccordionProps['onChange'];
  expandIcon?: ReactNode;
  disableExpandIconRotation?: boolean;
} & PropsWithChildren;

export function ActionAccordion({
  title,
  description,
  defaultExpanded,
  disabled,
  children,
  status,
  expanded,
  onChange,
  expandIcon,
  disableExpandIconRotation = false,
}: ActionAccordionProps) {
  const theme = useTheme();

  const resolvedExpandIcon =
    expandIcon ??
    (status ? (
      <StatusIcon value={status} />
    ) : (
      <StatusIcon value="" iconName="arrow-down" />
    ));

  return (
    <StyledAccordion
      {...getDataTestId(`accordion-${title}`)}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      expanded={expanded}
      onChange={onChange}
    >
      <AccordionSummary
        expandIcon={resolvedExpandIcon}
        sx={
          disableExpandIconRotation
            ? {
                '.MuiAccordionSummary-expandIconWrapper': {
                  transform: 'none',
                  '&.Mui-expanded': {
                    transform: 'none',
                  },
                },
              }
            : undefined
        }
      >
        <ListItem>
          <ListItemText>
            <Typography
              variant="h5"
              mb={0.5}
              color={theme.palette.text.primary}
            >
              {title}
            </Typography>
            <Typography variant="body2" color={theme.palette.text.secondary}>
              {description}
            </Typography>
          </ListItemText>
        </ListItem>
      </AccordionSummary>
      <DocumentAccordionDetails>{children}</DocumentAccordionDetails>
    </StyledAccordion>
  );
}
